import React, { memo, useEffect, useState } from 'react'
import { Alert, Card, Dialog, TextField, } from '@mui/material'

import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import MenuItem from '@material-ui/core/MenuItem'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Badge from '../../../components/Badge/Badge'
import ToggleButton from '@material-ui/lab/ToggleButton'
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup'
import { format, parse } from 'date-fns'
import { fr } from 'date-fns/locale'
import Button from '@mui/material/Button'
import CheckIcon from '@material-ui/icons/Check'
import Box from '@mui/material/Box'
import CloseIcon from '@material-ui/icons/Close'
import allActions from '../../../redux/actions/user'
import VirtualizedList from '../../../components/VirtualizedList'
import SearchIcon from '@material-ui/icons/Search'
import CardContent from '@material-ui/core/CardContent'
import { useHistory } from 'react-router'
import {useDispatch, useSelector} from "react-redux";
import {useSnackbar} from "notistack";

const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    borderRadius: 8,
    margin: 'unset !important',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion)

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    display: 'flex',
    alignItems:'center',
    gap: 16,
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary)

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    display: 'flex',
    gap: 16,
  },
}))(MuiAccordionDetails)

const StyledToggleButtonGroup = withStyles((theme) => ({
  grouped: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 16,
    border: 'none',
    '&:not(:first-child)': {
      borderRadius: theme.shape.borderRadius,
    },
    '&:first-child': {
      borderRadius: theme.shape.borderRadius,
    },
  },
}))(ToggleButtonGroup)

const StyledToggleButton = withStyles((theme) => ({
  root: {
    border: '1px solid #f5f5f5',
    borderRadius: 8,
    backgroundColor: 'rgba(33,150,243, 0.2)',
    '&:hover': {
      backgroundColor: 'rgba(33,150,243, 0.4)',
    },
  },

  '& > .MuiTypography-root': {
    color: '#000',
    fontWeight: '600',
  },
  selected: {
    backgroundColor: 'rgba(33,150,243, 0.8) !important',
  }
}))(ToggleButton)

const styles = makeStyles(theme => ({
  cardDialog: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  btnGroup: {
    display: 'flex',
    gap: 16,
    justifyContent: 'flex-end'
  },
  containerAccordion: {
    overflow: 'auto',
    flexGrow: 1,
    marginTop: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,

    [theme.breakpoints.down('700')]: {
      display: 'grid',
    },
  },
  grouped: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 16,
  },
  contentStep5: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
} ))

export default memo(({ classes, files, panier, filteredAllCenters, setFilter, filter }) => {
  const history = useHistory()
  const user = useSelector(state => state.user);
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()

  const [centre, setCentre] = useState(null)
  const [listActivites, setListActivites] = useState([])
  const classesStep = styles()
  const [expanded, setExpanded] = React.useState('panel0')
  const [creneauBtnSelected, setCreneauBtnSelected] = useState(null)
  const [creneauSelected, setCreneauSelected] = useState(null)
  const [confirm, setConfirm] = useState(false)
  const [allCreneau, setAllCreneau] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    dispatch(allActions.setLoading(false))
    if (centre) {
      const fetchDataCreneau = async () => {
        try {
          setLoading(true)
          dispatch(allActions.setLoading(true))
          const result = await allActions.fetchGetAPI(`api/planning/creneau-by-center/${centre.CNT_ID}`)
          setAllCreneau(result.json)
          setLoading(false)
          dispatch(allActions.setLoading(false))
        } catch (err) {
          console.log(err)
        }
      }

      fetchDataCreneau()
    }
  }, [centre])

  useEffect(() => {
    if (panier) {
      if(panier.length > 0) {
        setListActivites([])
        setCentre(panier[0].centre)

        const listActivites = []

        panier.map(item => {
          const activite = item.activite
          listActivites.push(activite)
        })

        setListActivites(listActivites)
      }
    }
  }, [panier])

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false)
  }

  const handleConfirmDialog = async () => {
    const listActivitiesID = listActivites.map(act => act.ACT_ID)
    dispatch(allActions.setLoading(true))

    const result = await allActions.fetchPostAPI('api/planning/creneau/book', {
      idCreneau: creneauSelected,
      licenceId: user.id,
      files: files,
      activities: listActivitiesID
    })

    const { res } = result

    if (!res?.ok) {
      dispatch(allActions.setLoading(false))
      enqueueSnackbar(`Erreur de validation`, { variant: 'error' })
      return console.log(res)
    }

    if (result?.res?.status === 200) {
      dispatch(allActions.setLoading(false))
      history.push('/mes-rendez-vous')
    }
  }

  function getColorByNumberSlots(number) {
    if (number >= 1 && number <= 2) return '#ff9800'
    if (number >= 3) return '#4caf50'
  }

  function parseDate(dateStr) {
    const date = parse(dateStr, 'yyyy-MM-dd', new Date())

    const formattedDate = format(date, 'EEEE dd MMMM', { locale: fr })

    return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1)
  }

  return (
    <div className={classes.contentStep5}>
      <Dialog open={confirm} onClose={() => setConfirm(false)}>
        <Card variant="outlined" sx={{ padding: 2 }} className={classesStep.cardDialog}>
          <Typography variant="h6">Confirmation rendez-vous</Typography>
          <Typography>
            Voulez-vous vraiment confirmer ce rendez-vous ?
            Après cette confirmation, un mail automatique sera envoyé au centre concernée
          </Typography>
          <Box className={classesStep.btnGroup}>
            <Button
              variant="contained"
              color="error"
              onClick={() => setConfirm(false)}
              startIcon={<CloseIcon />}
            >
              Annuler
            </Button>
            <Button
              variant="contained"
              color="success"
              onClick={handleConfirmDialog}
              startIcon={<CheckIcon />}
            >
              Confirmer
            </Button>
          </Box>
        </Card>
      </Dialog>
      {centre &&
        <TextField
          label="Centre"
          value={centre.CNT_LIBELLE}
          disabled
          fullWidth
        />
      }
      {listActivites.length > 0 &&
        <Card style={{ marginTop: 10, height: 'fit-content' }}>
          <CardContent>
            <h3 style={{ margin: 0, paddingBottom: 5 }}>Activité(s) concerné(es) :</h3>
            <div className={classesStep.grouped}>

              {listActivites?.map((act, i) => {
                return (
                  <Badge key={i} value={act.ACT_LIBELLE} style={{ fontSize: 12 }} color='#007fff'/>
                )
              })}
            </div>
          </CardContent>
        </Card>}
      {!centre && <div className={classesStep.contentStep5}>
        <Alert severity="info" style={{ alignItems: 'start' }}>
          Vous avez sélectionné "sans activité", veuillez choisir un centre pour continuer
        </Alert>
        <div className={`${classes.field} full`} >
          <SearchIcon />
          <TextField
            label="Recherche"
            size="small"
            fullWidth
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          />
        </div>
        <Card variant="outlined" className={`${classes.lists}`} className={'card-list'}>
          <VirtualizedList
            items={filteredAllCenters}
            selectedItem={centre}
            keyLibelle="CNT_LIBELLE"
            onItemClick={(centre) => {
              setCentre(centre)
            }}
          />
        </Card>
      </div>}
      {(!loading && allCreneau?.length <= 0) && <Alert severity="info" style={{ alignItems: 'start', marginTop: 10 }}>
        <div>
          Aucun créneau disponible pour le moment
        </div>
      </Alert>}
      {(!loading && allCreneau?.length > 0) && <div className={classesStep.containerAccordion}>
        {allCreneau?.map((creneau, i) =>
          <Accordion key={i} square expanded={expanded === 'panel'+i} onChange={handleChange('panel'+i)}>
            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMoreIcon />} >
              <Typography>{parseDate(creneau.date)}</Typography>
              <Badge value={creneau?.info?.length + 'créneaux'} color={getColorByNumberSlots(creneau?.info?.length)} />
            </AccordionSummary>
            <AccordionDetails>
              <StyledToggleButtonGroup
                size="small"
                value={creneauBtnSelected}
                exclusive
                onChange={(e, value) => {
                  setCreneauBtnSelected(value)
                }}
                className={classesStep.grouped}
                aria-label="text alignment"
              >
                {creneau?.info?.map((info, i) =>
                  <StyledToggleButton value={creneau?.date+' '+info?.hour} aria-label={info?.hour+i} key={i} onClick={() => {
                    setCreneauSelected(info.id)
                  }}>
                    <Typography>{info?.hour}</Typography>
                  </StyledToggleButton>
                )}
              </StyledToggleButtonGroup>
            </AccordionDetails>
          </Accordion>
        )}
        <Button
          type="submit"
          onClick={() => setConfirm(true)}
          variant="contained"
          color="success"
          fullWidth
          disabled={creneauBtnSelected === null}
          startIcon={<CheckIcon />}
        >
          Valider
        </Button>
      </div>}
    </div>
  )
})
